<template>
  <main>
    <div class="inner_wrap">
      <section class="content1">
        <div>
          <img
            src="@/assets/images/event/2024-exam/con1.png"
            alt="2학기 혜택"
          />
        </div>
        <div class="txt_wrap">
          <img
            src="@/assets/images/event/2024-exam/con1_txt.png"
            alt="중간고사응원 할인쿠폰"
          />
        </div>
      </section>
      <section class="content2">
        <article class="existing_member bene">
          <div class="circle" data-num="01"></div>
          <h2 class="main_topic">이벤트 할인 쿠폰팩</h2>
          <span class="sub_topic">전 도서 10% 할인쿠폰 증정!</span>
          <div class="coupon10">
            <img
              src="@/assets/images/event/2024-exam/coupon1.png"
              alt="10%쿠폰"
            />
          </div>
          <button class="receive" @click="oneTouchCouponDownload">
            <img
              src="@/assets/images/event/2024-exam/coupon_btn.png"
              alt="할인쿠폰 받기"
            />
          </button>
          <span class="coupon_detail">※쿠폰 세부기준 하기 참고</span>
        </article>
        <article class="new_member bene">
          <div class="circle" data-num="02"></div>
          <h2 class="main_topic">special gift</h2>
          <span class="sub_topic">신규가입 할인쿠폰 증정!</span>
          <div class="coupon10">
            <img
              src="@/assets/images/event/2024-exam/coupon2.png"
              alt="신규 10%쿠폰"
            />
          </div>
          <div class="coupon5">
            <img
              src="@/assets/images/event/2024-exam/coupon3.png"
              alt="신규 5%쿠폰"
            />
          </div>
          <button class="receive" @click="oneTouchCouponDownload">
            <img
              src="@/assets/images/event/2024-exam/coupon_btn.png"
              alt="할인쿠폰 받기"
            />
          </button>
          <span class="coupon_detail">※쿠폰 세부기준 하기 참고</span>
        </article>
      </section>
      <div class="caution_wrap" @click="toggleCaution(0)">
        <span class="txt"> 유의사항 {{ cautionStates[0] ? '-' : '+' }} </span>
        <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <ul v-show="cautionStates[0]" class="slide_list">
            <li>
              · 쿠폰 적용 스토어 및 유효기간은 마이페이지 > 쿠폰에서 확인
              가능합니다. (일부 스토어 상품 적용 불가)
            </li>
            <li>
              · 쿠폰은 ID당 1회 다운로드 가능합니다.
            </li>
            <li>
              · 쿠폰은 유효기간 만료 후 소멸되며, 유효기간 만료 및 변심 취소로
              인한 쿠폰 재발급은 불가합니다.
            </li>
            <li>
              · 장바구니 쿠폰 사용 후 일부를 부분 취소/반품하는 경우 쿠폰
              재발급은 불가합니다.
            </li>
            <li>
              · 이벤트 도서와 상품쿠폰은 중복 사용이 불가합니다.
            </li>
            <li>
              · 은행 점검 시간인 경우 일시적으로 결제가 어려울 수 있으니 점검
              시간 이후 재결제해주시길 바랍니다.
            </li>
            <li>
              · 쿠폰 및 이벤트는 당사 사정에 의하여 변경 및 조기 종료될 수
              있습니다.
            </li>
            <li>
              · 쿠폰은 유효기간 만료 후 소멸되며, 유효기간 만료 및 변심 취소로
              인한 쿠폰 재발급은 불가합니다.
            </li>
            <li>
              · 쿠폰 및 이벤트는 당사 사정에 의하여 변경 및 조기 종료될 수
              있습니다.
            </li>
          </ul>
        </transition>
      </div>
    </div>
    <Transition name="modal-fade">
      <Modal v-if="showCouponModal" @close="toggleCouponModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleCouponModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <span class="cart_alert_msg">
                  <p>{{ couponMessage }}</p>
                  <!-- <p>할인 쿠폰이 발급되었습니다.</p> -->
                  <!-- <p>주문시 사용가능합니다.</p> -->
                </span>
              </div>
              <div class="btn_wrap">
                <button class="box_btn dull" @click="toggleCouponModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
                <button class="box_btn" @click="navigateToCoupon">
                  <span class="an_t">
                    쿠폰함으로 이동
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal v-if="showCouponErrorModal" @close="toggleCouponErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleCouponErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <span class="cart_alert_msg">
                  <!-- <p>쿠폰 수령 횟수를 초과했습니다</p> -->
                  <!-- <p>쿠폰은 3회까지 다운로드 가능합니다</p> -->
                  <p>{{ couponErrorMessage }}</p>
                </span>
              </div>
              <div class="btn_wrap">
                <button class="box_btn dull" @click="toggleCouponErrorModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Transition>
  </main>
</template>
<script>
import { ONE_TOUCH_COUPON } from '@/store/types'
import { mapGetters } from 'vuex'
import swiperSettings from '@/data/swiperSettings'
export default {
  name: 'ExamEvent',
  data() {
    return {
      cautionStates: [false, false],
      couponMessage: '',
      couponErrorMessage: '',
      showCouponModal: false,
      showCouponErrorModal: false,
      ...swiperSettings
    }
  },
  computed: {
    ...mapGetters(['getCurrentUser'])
  },
  methods: {
    toggleCaution(index) {
      this.$set(this.cautionStates, index, !this.cautionStates[index])
    },
    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter(el) {
      const height = el.scrollHeight
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = `${height}px`
      el.style.opacity = '1'
    },
    leave(el) {
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = '0'
      el.style.opacity = '0'
    },
    toggleCouponModal() {
      this.showCouponModal = !this.showCouponModal
    },
    toggleCouponErrorModal() {
      this.showCouponErrorModal = !this.showCouponErrorModal
    },
    async oneTouchCouponDownload() {
      if (!this.getCurrentUser) {
        if (confirm('로그인이 필요합니다. 로그인 하시겠습니까?')) {
          this.$router.push({ name: 'login' })
          return
        } else {
          return
        }
      }
      // 이 아래 쿠폰 받기 구현.
      // 클릭하면 받으시겠습니까? 질문 없이 즉시 받기
      // 받고나서 확인 + 쿠폰함 이동 버튼 - LIKE 책을 장바구니에 넣었을 때처럼

      // 쿠폰 수령 후 알림창 띄워주는 부분.
      // 알림창은 장바구니 부분을 참고하여 만들어 짐.
      let resp = await this.$store.dispatch(ONE_TOUCH_COUPON)
      let result = resp.data.result
      switch (result.state) {
        case 'success':
          this.couponMessage = result.modal
          this.showCouponModal = true
          break
        case 'fail':
          this.couponErrorMessage = result.modal
          this.showCouponErrorModal = true
          break
        case 'error':
          alert(result.message)
          break
        default:
          console.log('out of case')
      }
    },
    navigateToCoupon() {
      this.$router.push({ name: 'discount' })
    }
  }
}
</script>
<style lang="scss" scoped>
// apply
img {
  width: 100%;
  height: 100%;
}
main {
  width: 100%;
}
section {
  position: relative;
  width: 100%;
}
.inner_wrap {
  max-width: 1120px;
  margin: 0 auto;
  text-align: center;
}
.circle {
  position: relative;
  display: inline-block;
  margin-bottom: 25px;
  width: 99px;
  height: 99px;
  background: #f85aef;
  border-radius: 50%;
  &::before {
    content: attr(data-num);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 43px;
    color: #fff;
  }
}
.main_topic {
  margin-bottom: 15px;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 52px;
  letter-spacing: 1px;
}
.sub_topic {
  display: block;
  margin-bottom: 75px;
  font-weight: 600;
  font-size: 42px;
  line-height: 42px;
  color: #f1f0f0;
}
.coupon10 {
  position: relative;
  margin: 0 auto 35px;
  width: 65%;
  &::after {
    content: 'X3';
    position: absolute;
    top: -45px;
    right: -40px;
    width: 110px;
    height: 110px;
    border: 4px solid #fc6de4;
    border-radius: 100%;
    background-color: #fff57d;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 46px;
    line-height: 110px;
    color: #000000;
  }
}
.coupon5 {
  margin: 0 auto 35px;
  width: 65%;
}
.receive {
  display: inline-block;
  // width: 47%;
}
.coupon_detail {
  display: block;
  margin-top: 30px;
  font-weight: 600;
  font-size: 32px;
  line-height: 32px;
  color: #d8d8d8;
}
.caution_wrap {
  padding: 100px 100px 65px;
  margin-bottom: 60px;
  background-color: #353535;
  user-select: none;
  cursor: pointer;
  .txt {
    display: block;
    margin-bottom: 50px;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 51px;
    line-height: 51px;
    color: #7c7c7c;
  }
  .slide_list {
    width: 600px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    list-style-type: disc;
    li {
      margin-bottom: 20px;
      font-size: 29px;
      color: #7c7c7c;
    }
  }
}
.select_wrap {
  display: flex;
  border: 1px solid #ffffff;
  li {
    flex: 1;
    padding: 55px 0;
    background-color: #8c88ff;
    border-right: 1px solid #ffffff;
    text-transform: uppercase;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 40px;
    color: #ffffff;
    cursor: pointer;
    &:last-child {
      border-right: none;
    }
  }
}
.use_method {
  margin-top: 30px;
  font-weight: 600;
  font-size: 26px;
  line-height: 26px;
  letter-spacing: 1px;
  color: #d8d8d8;
}

// cont
.content1 {
  // height: 1205px;
  background-color: #fedfee;
  img {
    display: block;
  }
  .txt_wrap {
    position: absolute;
    top: 145px;
    left: 50%;
    transform: translateX(-50%);
    width: 687px;
  }
}
.content2 {
  padding-top: 70px;
  padding-bottom: 70px;
  background: #5953b3;
  background-size: cover;
  .existing_member {
    position: relative;
    background-color: #3f3b99;
    border-radius: 70px;
    padding: 55px 0;
    width: 80%;
    margin: 0 auto;
    .main_topic {
      color: #fff57d;
    }
    .coupon10 {
      &::after {
        border: none;
        background: #f85aef;
        color: #fff;
      }
    }
  }
  .new_member {
    position: relative;
    background-color: #3f3b99;
    width: 80%;
    margin: 42px auto 0;
    padding: 55px 0;
    border-radius: 80px;
    .main_topic {
      text-transform: uppercase;
      color: #fff57d;
    }
  }
}
// 얼럿창 스타일
.ly_pop_msg .cell {
  height: auto;
  padding-bottom: 0;
  p {
    color: #008df3;
  }
}
@media (max-width: 960px) {
  .content2 .existing_member .sub_topic {
    &::before {
      left: 20px;
      width: 100px;
      height: 100px;
    }
  }
  .content2 .new_member .sub_topic {
    &::after {
      right: 20px;
      width: 100px;
      height: 100px;
    }
  }
  .content3 .main_topic {
    &::before {
      left: 10px;
    }
  }
  .content3 .sub_topic {
    &::after {
      right: 10px;
    }
  }
  .content3 .price {
    &::before {
      left: 0;
    }
  }
  .content3 .bottom_txt {
    &::after {
      right: 0;
    }
  }
}
@media (max-width: 768px) {
  //apply
  .circle {
    margin-bottom: 13px;
    width: 66px;
    height: 66px;
    &::before {
      font-size: 25px;
    }
  }
  .main_topic {
    margin-bottom: 8px;
    font-size: 5.5vw;
  }
  .sub_topic {
    margin-bottom: 40px;
    font-size: 4.7vw;
    line-height: 4.7vw;
  }
  .receive {
    padding: 18px 0;
    border-radius: 10px;
    line-height: 25px;
    font-size: 24px;
    width: 61%;
  }
  .coupon_detail {
    margin-top: 15px;
    font-size: 19px;
    line-height: 19px;
  }
  .coupon10 {
    margin: 0 auto 17px;
    width: 60%;
    &::after {
      top: -25px;
      right: -24px;
      width: 75px;
      height: 75px;
      border: 2px solid #fc6de4;
      font-size: 27px;
      line-height: 75px;
    }
  }
  .coupon5 {
    margin: 0 auto 17px;
    width: 60%;
  }
  .caution_wrap {
    padding: 45px 0 5px;
    .txt {
      font-size: 28px;
      line-height: 28px;
      letter-spacing: 1px;
    }
    .slide_list {
      width: 460px;
      li {
        font-size: 21px;
      }
    }
  }
  .select_wrap {
    li {
      padding: 23px 0;
      font-size: 21px;
    }
  }
  .use_method {
    margin-top: 13px;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: -0.2px;
  }
  // cont
  .content1 {
    .txt_wrap {
      top: 105px;
      width: 500px;
    }
  }
  .content2 {
    padding-top: 60px;
    padding-bottom: 50px;
    .existing_member {
      .sub_topic {
        &::before {
          width: 60px;
          height: 60px;
        }
      }
    }
    .new_member {
      margin-top: 40px;
      .sub_topic {
        &::after {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
  .content3 {
    padding: 40px 0;
    .main_topic {
      &::before {
        top: -35px;
        width: 60px;
        height: 60px;
      }
    }
    .sub_topic {
      &::after {
        top: 35px;
        right: -10px;
        width: 60px;
        height: 60px;
      }
    }
    .book_mock {
      margin: 0 auto 30px;
      width: 68%;
      li {
        // height: 228px;
      }
    }
    .bottom_txt {
      margin-bottom: 23px;
      font-size: 29px;
      line-height: 35px;
      &::after {
        width: 60px;
        height: 60px;
      }
    }
    .price {
      margin-bottom: 20px;
      font-size: 43px;
      line-height: 43px;
      &::before {
        top: 15px;
        width: 60px;
        height: 60px;
      }
    }
  }
  .content4 {
    padding: 40px 0 0;
    .pad_mock {
      margin-bottom: 15px;
    }
  }
  .content5 {
    padding: 40px 0 17px 0;
    .period {
      margin-bottom: 40px;
      font-size: 16px;
      line-height: 16px;
    }
    .main_topic {
      margin-bottom: 5px;
    }
    .sub_topic {
      margin-bottom: 10px;
    }
  }
}
@media (max-width: 480px) {
  //apply
  .circle {
    margin-bottom: 6px;
    width: 48px;
    height: 48px;
    &::before {
      font-size: 19px;
    }
  }
  .main_topic {
    margin-bottom: 6px;
  }
  .sub_topic {
    margin-bottom: 27px;
  }
  .receive {
    padding: 16px 0;
    line-height: 18px;
    font-size: 18px;
  }
  .coupon_detail {
    margin-top: 10px;
    font-size: 13px;
    line-height: 13px;
  }
  .coupon10 {
    &::after {
      width: 50px;
      height: 50px;
      font-size: 20px;
      line-height: 50px;
    }
  }
  .coupon10,
  .coupon5 {
    margin: 0 auto 12px;
  }
  .caution_wrap {
    padding: 35px 0 10px;
    .txt {
      margin-bottom: 22px;
      font-size: 20px;
      line-height: 20px;
    }
    .slide_list {
      width: 360px;
      li {
        font-size: 16px;
      }
    }
  }
  .select_wrap {
    li {
      padding: 18px 0;
      font-size: 16px;
    }
  }
  .use_method {
    margin-top: 9px;
    font-size: 11px;
    line-height: 11px;
    letter-spacing: -0.2px;
  }
  //cont
  .content1 {
    .txt_wrap {
      top: 60px;
      width: 300px;
    }
  }
  .content2 {
    padding-top: 40px;
    padding-bottom: 40px;
    .existing_member {
      width: 83%;
      padding: 24px 0;
      border-radius: 20px;
    }
    .new_member {
      margin-top: 30px;
      width: 83%;
      padding: 24px 0;
      border-radius: 20px;
    }
  }
  .content3 {
    padding: 30px 0;
    .book_mock {
      margin: 0 auto 21px;
      li {
        // height: 155px;
      }
    }
    .bottom_txt {
      margin-bottom: 11px;
      font-size: 20px;
      line-height: 25px;
    }
    .price {
      margin-bottom: 15px;
      font-size: 31px;
      line-height: 31px;
    }
  }
  .content4 {
    padding: 30px 0 0;
    .pad_mock {
      margin-bottom: 12px;
    }
  }
  .content5 {
    padding: 30px 0 12px 0;
    .period {
      margin-bottom: 30px;
      font-size: 13px;
      line-height: 13px;
    }
  }
}
</style>
